// datatable related plugins
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import React, { useEffect, useState } from "react";
import { Comparator, dateFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Card, CardBody, Col, Row } from "reactstrap";
import {
  getListNoticeFromTCT,
  resetListRegistryDelegate,
  setColumnVisibleNoticeFromTCT,
} from "store/actions";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const ListData = props => {
  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);

  const toggleViewDetailModal = () => setModalDetail(!modalDetail);
  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const noticeTCT = useSelector(state => state.noticeTCT);
  const { loading, listData, totalCount, columnsVisible, params } =
    noticeTCT.noticeFromTCT;

  const { t } = useTranslation(["noticeFromTCT"]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (tenantCodeHeader) {
      params.page = 1;
      dispatch(getListNoticeFromTCT(params));
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    initColumn();
  }, [t]);

  useEffect(() => {
    initColumn();
    return () => {
      dispatch(resetListRegistryDelegate());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      //   setDataDetail({
      //     content: row.content,
      //     file_name: row.file_name,
      //     process_upload_id: row.id,
      //     status: row.status,
      //   });
      //   toggleViewDetailModal();
    },
  };

  const listRowAction = [
    // {
    //   icon: <i className="bx bx-download font-size-18 text-primary" />,
    //   text: t("processUploadDocument:downloadUploadFile"), // Tải file gốc đã upload,
    //   onClick: row => {
    //     // downloadFile(row.id, row.file_name);
    //   },
    // },
  ];

  const initColumns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "message_type_id",
      text: t("field.message_type_id"),
      hidden: false,
    },
    {
      dataField: "message_content",
      text: t("field.message_content"),
      hidden: false,
    },
    {
      dataField: "message_status",
      text: t("field.message_status"),
      hidden: false,
    },
    {
      dataField: "maker_date",
      text: t("field.maker_date"),
      sort: true,
      formatter: (cellContent, row) =>
        Intl.DateTimeFormat("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }).format(row.maker_date * 1000),
      filter: dateFilter({
        comparators: [
          Comparator.GT,
          Comparator.GE,
          Comparator.LT,
          Comparator.LE,
        ],
        defaultValue: { comparator: Comparator.GE },
      }),
    },
    {
      dataField: "maker.display_name",
      text: t("field.maker_id"),
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      hidden: true,
    },
    {
      dataField: "checker_date",
      text: t("field.checker_date"),
      sort: true,
      formatter: (cellContent, row) =>
        Intl.DateTimeFormat("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }).format(row.checker_date * 1000),
      filter: dateFilter({
        comparators: [
          Comparator.GT,
          Comparator.GE,
          Comparator.LT,
          Comparator.LE,
        ],
        defaultValue: { comparator: Comparator.GE },
      }),
    },
    {
      dataField: "checker.display_name",
      text: t("field.checker_id"),
      sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      hidden: true,
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getListNoticeFromTCT(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListNoticeFromTCT(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleNoticeFromTCT(field, value));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.common")}</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={t("title.common") + ` (${totalCount})`}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    ></RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
